import config from "../../app/config";
import { VWQIcon } from "@sunwing/icons";
import styles from "./AlertNote.module.scss";
import { RCL } from "../RCL";

const AlertNote = () => { 

     const noteContent = (config.brand === 'vwq') ? RCL({ searchKey: "please-notes-westjet-vacations-quebec-solely-sells" })
             : RCL({ searchKey: "westjet-vacation-home-note" });

    return (
      <>
        {noteContent !== "#" && (<>
          <div className={styles.westJetBarRowContainer}>
            <div className={styles.westJetBarFirstRow}> 
                <VWQIcon name="status-info" alt="info" className={styles.westJetBarInfoIcon} /> 
                <div className={styles.westJetBarHeader}>
                  {<RCL searchKey="please-note" />}
                </div>
            </div>
          </div>
          <div className={styles.westJetBarSecondRowContainer}>
            <div className={styles.westJetBarSecondRow}> 
              <div className={styles.westJetBarSpaceHolder}></div>
              <div className={styles.westJetBarContent}>
                {noteContent}
              </div>
            </div>
          </div>
        </>)}
      </>
    )
}

export default AlertNote;